import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SuggestItem } from "../models/SuggestItem";
import { SuggestFilter } from "./siteSearchSlice";

export interface SiteSearchInputState {
  keywords: string;
  suggestions: SuggestItem[];
  isLoading: boolean;
  initDone: boolean;
}

const initialState: SiteSearchInputState = {
  keywords: "",
  suggestions: [],
  isLoading: false,
  initDone: false,
};

export const siteSearchInputSuggest = createAsyncThunk<SuggestItem[], SuggestFilter>(
  "data/siteSearchInputSuggest",
  async (payload: SuggestFilter): Promise<SuggestItem[]> => {
    const response = await fetch("/sitesearch/suggest", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }
    return (await response.json()) as SuggestItem[];
  }
);

export const siteSearchSlice = createSlice({
  name: "siteSearchSlice",
  initialState,
  reducers: {
    changeKeywords: (state, action: PayloadAction<string>) => {
      state.keywords = action.payload;
    },
    changeInit: (state, action: PayloadAction<boolean>) => {
      state.initDone = action.payload;
    },
    clearSuggestions: (state) => {
      state.suggestions = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(siteSearchInputSuggest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        siteSearchInputSuggest.fulfilled,
        (state, action: PayloadAction<SuggestItem[]>) => {
          state.isLoading = false;

          state.suggestions = [];

          if (action.payload.length > 0) {
            state.suggestions = [...action.payload];
          }
        }
      )
      .addCase(siteSearchInputSuggest.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const {
  changeKeywords,
  changeInit,
  clearSuggestions,
} = siteSearchSlice.actions;

export default siteSearchSlice.reducer;
